export type Currency = 'EUR' | 'USD' | 'SGD' | 'GBP'

export interface PricingTier {
  id: string
  title: string
  subtitle: string
  price: Record<Currency, string>
  variant: 'capacity' | 'time'
  tierColor: string
  delay: number
  units?: number
  maxUnits?: number
  onDark?: boolean
  breakdown?: string
  example?: string
  timeLabel?: string
  timeSub?: string
  description: string
  features: string[]
  isPopular?: boolean
}

export async function getPricingTiers(): Promise<PricingTier[]> {
  const res = await fetch('/api/cms/pricing_tiers')
  const body = await res.json()
  if (!body.ok) throw new Error(body.error || 'Failed to fetch pricing tiers')
  return body.data as PricingTier[]
}
